import { atom } from 'recoil';

export type PETColorMap = {
    id: number;
    name: string;
    stops: Array<{
        position: number;
        color: [number, number, number];
    }>;
    previewGradient: string;
};

export const defaultPETColorMap: PETColorMap = {
    id: 0,
    name: 'Hot Iron',
    stops: [
        { position: 0.0, color: [0.0, 0.0, 0.0] },
        { position: 0.333, color: [1.0, 0.0, 0.0] },
        { position: 0.667, color: [1.0, 1.0, 0.0] },
        { position: 1.0, color: [1.0, 1.0, 1.0] },
    ],
    previewGradient:
        'linear-gradient(to right, #000000 0%, #ff0000 33%, #ffff00 67%, #ffffff 100%)',
};

export const selectedPETColorMappingState = atom<PETColorMap>({
    key: 'selectedPETColorMappingState',
    default: defaultPETColorMap,
});

export const petMaxSuvState = atom<number | null>({
    key: 'petMaxSuvState',
    default: null,
});
